/** 情报 OpinionBarAndLineChart 根节点 class，用于隔离样式，避免影响舆情模块 */
export const OPINION_BAR_AND_LINE_CHART_ROOT_CLASS =
  'dbi-opinion-bar-and-line-chart';
